import { createContext } from 'react';

export const KYXContext = createContext();

export const KYXProvider = ({ value, children }) => {
    return <KYXContext.Provider value={value}>{children}</KYXContext.Provider>;
};

export default KYXProvider;
